import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { RoleUpdateInput } from "@colab/shared";

export type UpdateRoleInput = {
  id: string;
  patch: RoleUpdateInput;
};

// PATCH /api/settings/roles/:id
//
// Replaces revalidatePath("/admin/settings/roles/${id}") +
// revalidatePath("/admin/settings/roles") from
// /app/admin/settings/roles/_actions.ts::updateRole.
export function useUpdateRole() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, UpdateRoleInput>({
    mutationFn: ({ id, patch }) =>
      apiFetch<{ ok: true }>(`/settings/roles/${id}`, {
        method: "PATCH",
        body: JSON.stringify(patch),
      }),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.roles() });
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.role(id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.audit() });
    },
    onError: (err) => {
      if (err.code === "system_role_protected") {
        toast.error("System roles only accept description changes.");
        return;
      }
      toast.error(err.message ?? "Failed to update role");
    },
  });
}
